import React, { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);
export const useCart = () => useContext(CartContext);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("agoo_cart")) || []; } catch { return []; }
  });

  useEffect(() => { localStorage.setItem("agoo_cart", JSON.stringify(items)); }, [items]);

  const add = (product, qty = 1) => {
    setItems((prev) => {
      const found = prev.find((i) => i.product_id === product.id);
      if (found) return prev.map((i) => i.product_id === product.id ? { ...i, quantity: i.quantity + qty } : i);
      return [...prev, {
        product_id: product.id, name: product.name, price: product.price,
        image: product.image, quantity: qty, seller_name: product.seller_name,
      }];
    });
  };

  const remove = (pid) => setItems((prev) => prev.filter((i) => i.product_id !== pid));
  const setQty = (pid, qty) => setItems((prev) => prev.map((i) => i.product_id === pid ? { ...i, quantity: Math.max(1, qty) } : i));
  const clear = () => setItems([]);

  const count = items.reduce((s, i) => s + i.quantity, 0);
  const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);

  return (
    <CartContext.Provider value={{ items, add, remove, setQty, clear, count, subtotal }}>
      {children}
    </CartContext.Provider>
  );
}
